import DraggableService from './DraggableService';

export default DraggableService;